export type GameInfoSettingsProps = {
  game?: {
    turnLength?: number;
    maxFollowingTurns?: number;
    maxTurnsWithoutAction?: number;
  };
};

export default function GameInfoSettings({
  game: {
    turnLength,
    maxFollowingTurns,
    maxTurnsWithoutAction,
  } = {},
}: GameInfoSettingsProps) {
  const inputClass =
    'w-16 border border-bk-border bg-bk-bg px-2 text-bk-text focus:outline-none';

  return (
    <div className="flex w-full min-w-fit flex-col space-y-4 border border-bk-gold-dim/40 bg-bk-panel p-4 shadow-lg md:w-96">
      <h3 className="w-full border-b border-bk-gold-dim/40 pb-2 text-center text-lg font-bold uppercase tracking-wider text-bk-gold sm:text-xl md:text-2xl">
        Game Settings
      </h3>
      <div className="flex justify-between gap-4 text-bk-muted">
        <div className="min-w-fit">Turn Length (seconds)</div>
        <input
          className={inputClass}
          type="number"
          readOnly
          value={turnLength ?? ''}
        />
      </div>
      <div className="flex justify-between gap-4 text-bk-muted">
        <div className="min-w-fit">Turns Without Action</div>
        <input
          className={inputClass}
          type="number"
          readOnly
          value={maxTurnsWithoutAction ?? ''}
        />
      </div>
      <div className="flex justify-between gap-4 text-bk-muted">
        <div className="min-w-fit">Max Following</div>
        <input
          className={inputClass}
          type="number"
          readOnly
          value={maxFollowingTurns ?? ''}
        />
      </div>
    </div>
  );
}
